import {
  ObservableState,
  persistentReducedStream,
  reducer,
} from '@ardoq/rxbeach';
import {
  selectionToggle,
  componentTreeSelectionChanged,
  componentTreeSelectionStartSelected,
  ComponentSelection,
  componentSelectionOperations,
} from '@ardoq/component-selection';
import { actionNamespaceComponentHierarchy } from '@ardoq/global-consts';

export const componentHierarchySelection$: ObservableState<ComponentSelection> =
  persistentReducedStream(
    'componentHierarchySelection$',
    {
      graphSelection: [],
      treeSelection: [],
      selectionStart: '',
    },
    [
      reducer(
        componentTreeSelectionStartSelected,
        componentSelectionOperations.componentTreeSelectionStartSelected
      ),
      reducer(
        componentTreeSelectionChanged,
        componentSelectionOperations.componentTreeSelectionChanged
      ),
      reducer(
        selectionToggle,
        componentSelectionOperations.toggleTreeSelectionKeepingSelectionStart
      ),
    ],
    { namespace: actionNamespaceComponentHierarchy }
  );
